import { ICorporationResponse } from '@kcftech/prometheus-client';
import { ArrowLinkEditorRenderer } from 'components/link/ArrowLink';
import { CorporationNameInlineEditor } from 'pages/Settings/Corporations/CorporationNameInlineEditor';
import { getSingleCorporationRoute } from 'utils/RouteHelper';

export type CorporationNameCellProps = Readonly<{
    rowData: ICorporationResponse;
    onChange: () => void;
}>;

export function CorporationNameCell({ rowData, onChange }: CorporationNameCellProps) {
    return (
        <CorporationNameInlineEditor
            corporation={rowData}
            onChange={onChange}
            renderValue={(value) => (
                <ArrowLinkEditorRenderer
                    value={value}
                    to={getSingleCorporationRoute(rowData.Id)}
                    title="Select corporation"
                />
            )}
        />
    );
}
